import { Component, forwardRef, Inject, Input } from '@angular/core';
import { UIRouter }                             from '@uirouter/core';

import { BookingsService }      from './bookings.service';
import { CompanySettingsModel } from '../../app-lite/companies/models/company.settings';
import { MessagesService }      from '../../app-lite/messages/messages.service';
import { SessionService }       from '../../app-lite/sessions/session.service';

@Component({
  selector   : 'wor-bookings-api-key',
  template: require('./bookings.api-key.component.html')
})
export class BookingsApiKeyComponent {
  @Input() settings: CompanySettingsModel;

  constructor (
    @Inject(forwardRef(() => BookingsService))
    private bookingsService : BookingsService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    public  sessionService  : SessionService,
  ) {}

  generateApiKey () : void {
    this.bookingsService.generateApiKey()
    .then(() => this.router.stateService.reload())
    .catch(error => this.messagesService.error(error));
  }
}
